import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../template/store";
import axiosInstance, { axiosCacheInstance } from "../../../axiosSetup";
import { NavigationType } from "react-router-dom";
import axios, { AxiosError } from "axios";

export const submitCustomerCodeRequest = createAsyncThunk('customerCodeRequest/submitCustomerCodeRequest',
    async (payload: any, { getState }: any) => {
        const state: RootState = getState()
        try {
            const response: any = await axiosInstance.post(
                `/api/user-management/v1/customer/submitCustomerCodeRequest`, payload
            )
            return response.data;
        } catch (e: any) {
            const error = e as AxiosError;
            console.error(error);
            return {};
        }
    }
)

export const approveRejectCustomerCodeRequest = createAsyncThunk('customerCodeRequest/approveRejectCustomerCodeRequest',
    async (payload: any, { getState }: any) => {
        const state: RootState = getState()
        try {
            const response: any = await axiosInstance.post(
                `/api/user-management/v1/customer/approveRejectCustomerCodeRequest`, payload
            )
            return response.data;

        } catch (e: any) {
            const error = e as AxiosError;
            console.error(error);
            return {};
        }

    }
)

export const getCustomerCodeDetails = createAsyncThunk(
    'customerCodeRequest/getCustomerCodeDetails',
    async (payload: { custIdDecrypted: any, linerId: any, dataCountry: any }) => {
        try {

            const linerList = await axiosCacheInstance.get(
                `/api/edo-rest-v1/v1/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=ACTIVE_LINERS&countryCode=${payload.dataCountry}`, {
                cache: {
                    ttl: 10 * 60 * 1000
                }
            }
            );
            const options = linerList.data?.map((item: any) => ({
                value: item.codeId,
                text: item.codeDesc,
            }));

            const data = (await axiosInstance.get(
                `/api/user-management/v1/customer/getCustomerCodeByPartnerIdAndLinerId?mstPartnerId=${payload.custIdDecrypted}&linerId=${payload.linerId}`
            )).data
            return data?.map((row: any) => {
                const linerOption = options?.find(
                    (opt: any) => opt.value == row.linerId
                );
                return {
                    id: row?.customerMapId,
                    liner: row?.linerId,
                    linerName: linerOption?.text ?? row?.linerId,
                    customerCode: row?.mapCode,
                    matchCode: row?.internalCode,
                };
            });
        } catch {
            return []
        }
    })